<div class="h-100-p w-100-p" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <!--------------------- INFO DOS PACIENTE | FULL HD --------------------->
    <div fxLayout="row" class="h-100-p" style="max-height: 100%;" fxHide.lt-xl>

        <div [ngStyle]="{ 'display': !galleryMode ? 'flex' : 'none' }" fxLayout="column" class="w-80-p">
            <div fxLayout="row" fxLayoutAlign="start center">
                <div class="example-handle" cdkDragHandle>
                    <svg style=" pointer-events: stroke; color: rgb(8, 72, 83);" width="24px" fill="currentColor"
                        viewBox="0 0 24 24">
                        <path
                            d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z">
                        </path>
                        <path d="M0 0h24v24H0z" fill="none"></path>
                    </svg>
                </div>
                <div fxLayout="column" class="w-80-p">
                    <div class="h-20-p">
                        <h1 fxLayoutAlign="center center" mat-dialog-title>Captura</h1>
                        <button mat-icon-button (click)="activateGallery()" title="Galeria" color="accent">
                            <mat-icon>photo</mat-icon>
                        </button>
                    </div>
                    <div class="h-20-p">
                        <h2 fxLayoutAlign="center center" fxHide.lt-xl class="text-truncat">
                            {{data.patient?.person.name}}
                        </h2>
                        <h2 fxLayoutAlign="center center" fxHide.lt-lg fxHide.gt-lg class="text-truncat">
                            {{data.patient?.person.name}}
                        </h2>
                    </div>
                </div>
                <div></div>
            </div>

            <div fxLayout="column" class="h-100-p" mat-dialog-content>
                <div fxLayout="row" fxLayoutAlign="start center">
                    <div class="w-100-p">

                        <form class="w-100-p" [formGroup]="AttachmentGroup">

                            <mat-form-field class="w-100-p" appearance="outline">
                                <mat-label>Selecionar câmera</mat-label>
                                <mat-select [(value)]="selectedDeviceId" (selectionChange)="onDeviceChange()">
                                    <mat-option *ngFor="let device of videoDevices" [value]="device.deviceId">
                                        {{ device.label }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                        </form>

                    </div>
                </div>

                <div class="container" fxLayout="row">

                    <!-- Coluna do vídeo (60%) -->
                    <div class="video-container" fxFlex="60">
                        <video #videoElement autoplay (click)="captureFrame()"></video>
                        <canvas #canvasElement style="display: none;"></canvas>
                    </div>

                    <!-- Coluna direita (40%) -->
                    <div class="preview-container" fxFlex="40">

                        <img *ngIf="capturedImage" [src]="capturedImage" alt="Frame capturado" class="previewImage" />

                        <form class="w-100-p mt-10" [formGroup]="AttachmentGroup">

                            <mat-form-field *ngIf="capturedImage" appearance="outline" class="mt-10 w-90-p">
                                <mat-label>Descrição</mat-label>
                                <input matInput maxlength="250" formControlName="name" />
                            </mat-form-field>

                            <button *ngIf="capturedImage" (click)="insertDescription()" mat-icon-button color="accent">
                                <mat-icon>save</mat-icon>
                            </button>

                        </form>

                    </div>

                </div>

            </div>

        </div>

        <div fxLayout="column" class="w-20-p h-100-p" *ngIf="!galleryMode">
            <div fxLayout="row" fxLayoutAlign="center center">
                <h1 class="w-80-p" fxLayoutAlign="center center" mat-dialog-title>Historico dos Capturas</h1>
                <button mat-raised-button (click)="closeModal()" style="margin-top: -7%;" title="Fechar" color="accent">
                    <mat-icon>close</mat-icon>
                </button>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" style="overflow: auto;" class="h-90-p">

                <div class="w-100-p h-100-p">
                    <div class="card-container">
                        <mat-card class="attachment-card" *ngFor="let chip of attachmentList" (click)="selectRow(chip)">
                            <div class="card-header">
                                <div fxLayout="row" class="action-buttons">

                                    <mat-checkbox (change)="checkedCapture($event, chip)" type="checkbox"
                                        class="w-10-p mr-8">
                                    </mat-checkbox>
                                    <button mat-icon-button title="Deletar" (click)="deleteAttachement(chip)">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                    <button mat-icon-button title="Download" (click)="download(chip)">
                                        <mat-icon>cloud_download</mat-icon>
                                    </button>

                                    <p style="margin-left: 10px;">{{ chip.name}}</p>
                                </div>
                            </div>

                            <mat-card-content>
                                <div class="image-container">
                                    <img *ngIf="chip.eartefact.content" [src]="chip.eartefact.content"
                                        alt="Frame capturado">
                                </div>
                            </mat-card-content>

                            <mat-card-footer class="card-footer">
                                <p style="margin-left: 10px;">Data: {{ chip.dated | date: "dd/MM/yyyy" }}</p>
                            </mat-card-footer>
                        </mat-card>
                    </div>

                    <div style="position: sticky; bottom: 0; background: white; z-index: 10; padding: 8px 0;">
                        <mat-paginator #paginator showFirstLastButtons [length]="totalElements" [pageIndex]="pagina"
                            [pageSizeOptions]="[12, 24]" (page)="switchFind($event,'page')">
                        </mat-paginator>
                    </div>

                </div>

            </div>

        </div>

        <div fxLayout="column" class="w-100-p" *ngIf="galleryMode"
            style="height: 100vh; display: flex; flex-direction: column;">
            <!-- Botão fixo no topo -->
            <div class="h-10" style="position: sticky; top: 0; background: white; z-index: 10; padding: 8px 0;"
                fxLayout="row" fxLayoutAlign="start start">
                <div class="w-50-p">
                    <button mat-icon-button (click)="activateGallery()" title="Voltar" color="accent">
                        <mat-icon>arrow_back</mat-icon>
                    </button>

                    <button mat-icon-button (click)="print()" title="Imprimir" color="accent">
                        <mat-icon>print</mat-icon>
                    </button>
                </div>

                <h1 class="w-50-p" mat-dialog-title>Galeria</h1>
            </div>

            <!-- Conteúdo rolável -->
            <div style="flex: 1; overflow-y: auto; padding-bottom: 50px;">
                <div fxLayout="row wrap" fxLayoutAlign="space-around">
                    <mat-card class="gallery-card" *ngFor="let chip of attachmentList">
                        <div class="card-header">
                            <div fxLayout="row" class="action-buttons">
                                <mat-checkbox (change)="checkedCapture($event, chip)" type="checkbox"
                                    class="w-10-p mr-8">
                                </mat-checkbox>
                                <button mat-icon-button title="Deletar" (click)="deleteAttachement(chip)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                                <button mat-icon-button title="Download" (click)="download(chip)">
                                    <mat-icon>cloud_download</mat-icon>
                                </button>

                                <p style="margin-left: 10px;">{{ chip.name }}</p>
                            </div>
                        </div>

                        <mat-card-content>
                            <div class="image-container">
                                <img *ngIf="chip.eartefact.content" (click)="openImageDialog(chip)"
                                    [src]="chip.eartefact.content" alt="Frame capturado">
                            </div>
                        </mat-card-content>

                        <mat-card-footer class="card-footer">
                            <p style="margin-left: 10px;">Data: {{ chip.dated | date: "dd/MM/yyyy" }}</p>
                        </mat-card-footer>
                    </mat-card>
                </div>
            </div>

            <!-- Paginator fixo na parte inferior -->
            <div style="position: sticky; bottom: 0; background: white; z-index: 10; padding: 8px 0;">
                <mat-paginator #paginator showFirstLastButtons [length]="totalElements" [pageIndex]="pagina"
                    [pageSizeOptions]="[12, 24]" (page)="switchFind($event,'page')">
                </mat-paginator>
            </div>
        </div>


    </div>

    <!--------------------- INFO DOS PACIENTE | GRANDE --------------------->
    <div fxLayout="row" class="h-100-p" style="max-height: 100%;" fxHide.lt-lg fxHide.gt-lg>

        <div [ngStyle]="{ 'display': !galleryMode ? 'flex' : 'none' }" fxLayout="column" class="w-70-p">
            <div fxLayout="row" fxLayoutAlign="start" class="h-10-p">
                <div class="example-handle" cdkDragHandle>
                    <svg style=" pointer-events: stroke; color: rgb(8, 72, 83);" width="24px" fill="currentColor"
                        viewBox="0 0 24 24">
                        <path
                            d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z">
                        </path>
                        <path d="M0 0h24v24H0z" fill="none"></path>
                    </svg>
                    <button mat-icon-button (click)="activateGallery()" title="Galeria" color="accent">
                        <mat-icon>photo</mat-icon>
                    </button>
                </div>
                <div fxLayout="column" class="w-80-p">
                    <div class="h-20-p">
                        <h1 fxLayoutAlign="center center" mat-dialog-title>Capturas</h1>
                    </div>
                    <div class="h-20-p">
                        <h2 fxLayoutAlign="center center" fxHide.lt-xl class="text-truncat">
                            {{data.patient?.person.name}}
                        </h2>
                        <h2 fxLayoutAlign="center center" fxHide.lt-lg fxHide.gt-lg class="text-truncat">
                            {{data.patient?.person.name}}
                        </h2>
                    </div>
                </div>
            </div>

            <div fxLayout="column" class="h-100-p" mat-dialog-content>
                <div fxLayout="row" fxLayoutAlign="start center">
                    <div class="w-100-p">

                        <form class="w-100-p" [formGroup]="AttachmentGroup">

                            <mat-form-field class="w-100-p" appearance="outline">
                                <mat-label>Selecionar câmera</mat-label>
                                <mat-select [(value)]="selectedDeviceId" (selectionChange)="onDeviceChange()">
                                    <mat-option *ngFor="let device of videoDevices" [value]="device.deviceId">
                                        {{ device.label }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                        </form>

                    </div>
                </div>

                <div class="container" fxLayout="row">

                    <!-- Coluna do vídeo (60%) -->
                    <div class="video-container" fxFlex="60">
                        <video #videoElementHD autoplay (click)="captureFrame()"></video>
                        <canvas #canvasElementHD style="display: none;"></canvas>
                    </div>

                    <!-- Coluna direita (40%) -->
                    <div class="preview-container" fxFlex="40">

                        <img *ngIf="capturedImage" [src]="capturedImage" alt="Frame capturado" class="previewImage" />

                        <form class="w-100-p mt-10" [formGroup]="AttachmentGroup">

                            <mat-form-field *ngIf="capturedImage" appearance="outline" class="mt-10 w-90-p">
                                <mat-label>Descrição</mat-label>
                                <input matInput maxlength="250" formControlName="name" />
                            </mat-form-field>

                            <button *ngIf="capturedImage" (click)="insertDescription()" mat-icon-button color="accent">
                                <mat-icon>save</mat-icon>
                            </button>

                        </form>

                    </div>

                </div>
            </div>
        </div>

        <div [ngStyle]="{ 'display': !galleryMode ? 'flex' : 'none' }" fxLayout="column" class="w-30-p h-100-p">
            <div fxLayout="row" fxLayoutAlign="center center">
                <h1 class="w-80-p" fxLayoutAlign="center center" mat-dialog-title>Historico dos Capturas</h1>
                <button mat-raised-button (click)="closeModal()" style="margin-top: -7%;" title="Fechar" color="accent">
                    <mat-icon>close</mat-icon>
                </button>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" style="overflow: auto;" class="h-90-p">

                <div class="w-100-p h-100-p">
                    <div class="card-container">
                        <mat-card class="attachment-card" *ngFor="let chip of attachmentList" (click)="selectRow(chip)">
                            <div class="card-header">
                                <div fxLayout="row" class="action-buttons">
                                    <mat-checkbox (change)="checkedCapture($event, chip)" type="checkbox"
                                        class="w-10-p mr-8">
                                    </mat-checkbox>
                                    <button mat-icon-button title="Deletar" (click)="deleteAttachement(chip)">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                    <button mat-icon-button title="Download" (click)="download(chip)">
                                        <mat-icon>cloud_download</mat-icon>
                                    </button>
                                    <p style="margin-left: 10px;">{{ chip.name}}</p>
                                </div>
                            </div>

                            <mat-card-content>
                                <div class="image-container">
                                    <img *ngIf="chip.eartefact.content" [src]="chip.eartefact.content"
                                        alt="Frame capturado">
                                </div>
                            </mat-card-content>

                            <mat-card-footer class="card-footer">
                                <p style="margin-left: 10px;">Data: {{ chip.dated | date: "dd/MM/yyyy" }}</p>
                            </mat-card-footer>
                        </mat-card>
                    </div>

                    <div style="position: sticky; bottom: 0; background: white; z-index: 10; padding: 8px 0;">
                        <mat-paginator #paginator showFirstLastButtons [length]="totalElements" [pageIndex]="pagina"
                            [pageSizeOptions]="[12, 24]" (page)="switchFind($event,'page')">
                        </mat-paginator>
                    </div>
                </div>
            </div>

        </div>


        <div fxLayout="column" class="w-100-p" *ngIf="galleryMode"
            style="height: 100vh; display: flex; flex-direction: column;">
            <!-- Botão fixo no topo -->
            <div class="h-10" style="position: sticky; top: 0; background: white; z-index: 10; padding: 8px 0;"
                fxLayout="row" fxLayoutAlign="start start">
                <div class="w-50-p">
                    <button mat-icon-button (click)="activateGallery()" title="Voltar" color="accent">
                        <mat-icon>arrow_back</mat-icon>
                    </button>

                    <button mat-icon-button (click)="print()" title="Imprimir" color="accent">
                        <mat-icon>print</mat-icon>
                    </button>
                </div>

                <h1 class="w-50-p" mat-dialog-title>Galeria</h1>
            </div>

            <!-- Conteúdo rolável -->
            <div style="flex: 1; overflow-y: auto; padding-bottom: 50px;">
                <div fxLayout="row wrap" fxLayoutAlign="space-around">
                    <mat-card class="gallery-card" *ngFor="let chip of attachmentList">
                        <div class="card-header">
                            <div fxLayout="row" class="action-buttons">
                                <mat-checkbox (change)="checkedCapture($event, chip)" type="checkbox"
                                     class="w-10-p mr-8">
                                </mat-checkbox>
                                <button mat-icon-button title="Deletar" (click)="deleteAttachement(chip)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                                <button mat-icon-button title="Download" (click)="download(chip)">
                                    <mat-icon>cloud_download</mat-icon>
                                </button>

                                <p style="margin-left: 10px;">{{ chip.name }}</p>
                            </div>
                        </div>

                        <mat-card-content>
                            <div class="image-container">
                                <img (click)="openImageDialog(chip)" *ngIf="chip.eartefact.content"
                                    [src]="chip.eartefact.content" alt="Frame capturado">
                            </div>
                        </mat-card-content>

                        <mat-card-footer class="card-footer">
                            <p style="margin-left: 10px;">Data: {{ chip.dated | date: "dd/MM/yyyy" }}</p>
                        </mat-card-footer>
                    </mat-card>
                </div>
            </div>

            <!-- Paginator fixo na parte inferior -->
            <div style="position: sticky; bottom: 0; background: white; z-index: 10; padding: 8px 0;">
                <mat-paginator #paginator showFirstLastButtons [length]="totalElements" [pageIndex]="pagina"
                    [pageSizeOptions]="[12, 24]" (page)="switchFind($event,'page')">
                </mat-paginator>
            </div>
        </div>


    </div>

    <!--------------------- INFO DOS PACIENTE | MOBILE --------------------->
    <div fxLayout="column" fxHide.gt-md class="h-100-p capture-mobile-shell">
        <div class="capture-mobile-header" fxLayout="row" fxLayoutAlign="space-between center">
            <div class="example-handle" cdkDragHandle>
                <svg style="pointer-events: stroke; color: rgb(8, 72, 83);" width="22px" fill="currentColor"
                    viewBox="0 0 24 24">
                    <path
                        d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z">
                    </path>
                    <path d="M0 0h24v24H0z" fill="none"></path>
                </svg>
            </div>

            <div class="capture-mobile-title">
                <h1>Imagens</h1>
                <span>{{ data.patient?.person?.name }}</span>
            </div>

            <button mat-icon-button (click)="closeModal()" title="Fechar" color="accent">
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <div class="capture-mobile-tabs" fxLayout="row">
            <button mat-button [class.active]="!galleryMode" (click)="galleryMode = false" type="button">
                <mat-icon>photo_camera</mat-icon>
                Captura
            </button>
            <button mat-button [class.active]="galleryMode" (click)="galleryMode = true" type="button">
                <mat-icon>photo_library</mat-icon>
                Galeria
            </button>
            <button mat-button *ngIf="galleryMode" (click)="print()" type="button">
                <mat-icon>print</mat-icon>
                Imprimir
            </button>
        </div>

        <div class="capture-mobile-content" [ngStyle]="{ 'display': !galleryMode ? 'flex' : 'none' }">
            <form class="w-100-p" [formGroup]="AttachmentGroup">
                <mat-form-field class="w-100-p" appearance="outline">
                    <mat-label>Selecionar câmera</mat-label>
                    <mat-select [(value)]="selectedDeviceId" (selectionChange)="onDeviceChange()">
                        <mat-option *ngFor="let device of videoDevices" [value]="device.deviceId">
                            {{ device.label || 'Câmera' }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </form>

            <div class="capture-mobile-video">
                <video #videoElementMobile autoplay playsinline muted (click)="captureFrame()"></video>
                <canvas #canvasElementMobile style="display: none;"></canvas>
            </div>

            <button mat-raised-button color="accent" class="capture-mobile-button" (click)="captureFrame()"
                [disabled]="isSaving || !selectedDeviceId" type="button">
                <mat-icon>photo_camera</mat-icon>
                Capturar imagem
            </button>

            <div class="capture-mobile-preview" *ngIf="capturedImage">
                <img [src]="capturedImage" alt="Frame capturado" />
                <form class="w-100-p" [formGroup]="AttachmentGroup">
                    <mat-form-field appearance="outline" class="w-100-p">
                        <mat-label>Descrição</mat-label>
                        <input matInput maxlength="250" formControlName="name" />
                    </mat-form-field>
                    <button mat-raised-button color="primary" (click)="insertDescription()" type="button">
                        <mat-icon>save</mat-icon>
                        Salvar descrição
                    </button>
                </form>
            </div>
        </div>

        <div class="capture-mobile-content gallery" [ngStyle]="{ 'display': galleryMode ? 'flex' : 'none' }">
            <div class="capture-mobile-gallery">
                <mat-card class="gallery-card" *ngFor="let chip of attachmentList" (click)="selectRow(chip)">
                    <div class="card-header">
                        <div fxLayout="row" class="action-buttons">
                            <mat-checkbox (change)="checkedCapture($event, chip)" type="checkbox"
                                class="w-10-p mr-8">
                            </mat-checkbox>
                            <button mat-icon-button title="Deletar" (click)="deleteAttachement(chip)">
                                <mat-icon>delete</mat-icon>
                            </button>
                            <button mat-icon-button title="Download" (click)="download(chip)">
                                <mat-icon>cloud_download</mat-icon>
                            </button>
                            <p>{{ chip.name }}</p>
                        </div>
                    </div>

                    <mat-card-content>
                        <div class="image-container">
                            <img *ngIf="chip.eartefact.content" [src]="chip.eartefact.content" alt="Frame capturado">
                        </div>
                    </mat-card-content>

                    <mat-card-footer class="card-footer">
                        <p>Data: {{ chip.dated | date: "dd/MM/yyyy" }}</p>
                    </mat-card-footer>
                </mat-card>
            </div>

            <mat-paginator #paginator showFirstLastButtons [length]="totalElements" [pageIndex]="pagina"
                [pageSizeOptions]="[12, 24]" (page)="switchFind($event,'page')">
            </mat-paginator>
        </div>
    </div>
</div>
